
import { SearchHotelTransfer } from '@/types/models';
import { LocaleStrings } from '@/types/paramModels';
import { defineComponent, PropType, ref } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: "TransferOption",
  props: {
    transfer: {
      type: Object as PropType<SearchHotelTransfer>,
      required: true
    },
    id: {
      type: String || null,
      required: true
    },
    selectedTransferKey: {
      type: String,
      required: true
    },
    pageTexts: {
      type: Object,
      required: true
    },
    localeStrings: {
      type: Object as PropType<LocaleStrings>,
      required: true
    }
  },
  setup(_props) {
    const store = useStore();
    const showModal = ref(false);


    const openModal = (event: Event) => {
      event.preventDefault();
      showModal.value = true;
    }

    const closeModal = () => {
      showModal.value = false;
    }
    
    const fixBody = () => {
      document.body.classList.add("modal-active");
    }

    const unfixBody = () => {
      document.body.classList.remove("modal-active");
    }

    const optionStyle = ref({
      '--icon-selected': `url('${_props.transfer.iconSelected}')`,
      '--icon': `url('${_props.transfer.iconNotSelected}')`
    });

    const updateTransfer = (transfer: SearchHotelTransfer) => {
      store.dispatch('TravelSearchBookingModule/updateTransfer', transfer);
    }

    return {
      optionStyle,
      updateTransfer,
      showModal,
      openModal,
      closeModal,
      fixBody,
      unfixBody
    }
  },
})
